import TargetView from "./TargetView";
import InspectionTypeView from "./InspectionTypes/InspectionTypeView";
import VehicleTypeView from "./VehicleTypes/VehicleTypeView";
import Defaults from "./Defaults";
import React from "react";
import { useDefaultsData } from "../../hooks/useDefaultsData";
import { useSelector } from "react-redux";
import {getAppDefaultsData, getDataFresh, getMovementTypesData, getVehicleMakeData} from "../../state/selectors";
import TransactionsSettings from "./Transactions/TransactionsSettings";
import CostCentreView from "./CostCentres/CostCentreView";
import QuickLinkView from "./QuickLinks/QuickLinkView";
import JobWorkshopView from "./JobWorkshop/JobWorkshopView";
import DepartmentView from "./Departments/DepartmentView";
import FitterView from "./Fitter/FitterView";
import VehicleTrackerType from "./VehicleTrackerType/VehicleTrackerTypeView";
import VehicleDetails from "./VehicleDetails/VehicleDetails";
import RentalMargin from "./Rental/RentalMargin";
import WorkTypeView from "./WorkType/WorkTypeView";
import MovementRateView from "./MovementRate/MovementRateView";
import MovementTypeView from "./MovementType/MovementTypeView";
import PaymentTypeView from "./PaymentTypes/PaymentTypeView";
import DriverView from "./Driver/DriverView";
import NominalCodeView from "./NominalCodes/NominalCodeView";
import TrackingCategory from "./TrackingCategory/TrackingCategory";
import {useTransactionReportingCategoryData} from "../../hooks/useTransactionReportingCategoryData";
import {useTrackingOptionsData} from "../../hooks/useTrackingOptionsData";
import Test from "./TEST";
import RateCard from "./RateCards/RateCard";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import JobWorkshopConfig from "./JobWorkshopConfig/JobWorkshopConfig";

function Settings(props) {
  const dataFresh = useSelector(getDataFresh)
  const appDefaultsComplete = useDefaultsData({}, dataFresh);
  const appDefaults = useSelector(getAppDefaultsData);
  const reportingCategoryComplete = useTransactionReportingCategoryData({showhide:true}, dataFresh);
  let trackingOptionsLoaded = useTrackingOptionsData({page_size:1000});
  let departmentsLoading = useDepartmentsData({page_size: 1000}, dataFresh);


  document.title = "Rentals Direct App";

  return (
    <div>
      <TargetView loaded={departmentsLoading}/>
      <VehicleDetails {...props}/>
      <RentalMargin {...props}/>
      <VehicleTypeView {...props} />
      <VehicleTrackerType {...props}/>
      {reportingCategoryComplete && false &&
        <TransactionsSettings {...props} />
      }
      <InspectionTypeView {...props} />
      <NominalCodeView  {...props}/>
      <WorkTypeView {...props}/>
      <CostCentreView {...props} />
      <PaymentTypeView {...props}/>
      <QuickLinkView {...props} />
      {appDefaultsComplete  && (
        <Defaults {...props} appDefaultsData={appDefaults} />
      )}
      {reportingCategoryComplete &&
        <MovementTypeView {...props}/>
      }
      <MovementRateView {...props}/>
      <DriverView {...props}/>
      <JobWorkshopView/>
      <DepartmentView loading={departmentsLoading}/>
      <FitterView {...props}/>
      <TrackingCategory {...props}/>
      <RateCard {...props}/>
      <JobWorkshopConfig {...props}/>
    </div>
  );
}

export default Settings;
